import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro";
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";

import { ReactComponent as SvgDecoratorBlob3 } from "images/svg-decorator-blob-3.svg";

import getLocaleString from "utils/getLocaleString";
import { HiBuildingOffice2 } from "react-icons/hi2";
import { GiFactory, GiShop } from "react-icons/gi";
import { MdConstruction } from "react-icons/md";
import { FaSchool, FaHospitalAlt } from "react-icons/fa";

const Container = tw.div`relative`;

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-xl mx-auto py-20 md:py-24`}
`;
const Subheading = tw(SubheadingBase)`mb-4`;
const Heading = tw(SectionHeading)`w-full`;
const Description = tw(SectionDescription)`w-full text-center`;

const VerticalSpacer = tw.div`mt-10 w-full`;

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 max-w-sm`}
`;

const Card = styled.div`
  ${tw`flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left h-full mx-4 px-2 py-8`}
  .imageContainer {
    ${tw`border text-center rounded-full p-5 flex-shrink-0`}
    img {
      ${tw`w-6 h-6`}
    }
  }

  .textContainer {
    ${tw`sm:ml-4 mt-4 sm:mt-2`}
  }

  .title {
    ${tw`mt-4 tracking-wide font-bold text-2xl leading-none`}
  }

  .description {
    ${tw`mt-1 sm:mt-4 font-medium text-secondary-100 leading-loose`}
  }
`;

const DecoratorBlob = styled(SvgDecoratorBlob3)`
  ${tw`pointer-events-none absolute right-0 bottom-0 w-64 opacity-25 transform translate-x-32 translate-y-48 `}
`;

export default ({ locale }) => {
  const heading = (
      <>
        {getLocaleString("Feature2Heading1", locale)}
        <span tw="text-primary-500">
          {getLocaleString("Feature2Heading2", locale)}
        </span>
        {getLocaleString("Feature2Heading3", locale)}
      </>
    ),
    subheading = getLocaleString("Feature2SubHeading", locale),
    description = getLocaleString("Feature2Description", locale);
  /*
   * This componets has an array of object denoting the cards defined below. Each object in the cards array can have the key (Change it according to your need, you can also add more objects to have more cards in this feature component) or you can directly pass this using the cards prop:
   *  1) imageSrc - the image shown at the top of the card
   *  2) title - the title of the card
   *  3) description - the description of the card
   *  If a key for a particular card is not provided, a default value is used
   */

  const cards = [
    {
      icon: HiBuildingOffice2,
      title: getLocaleString("Feature2Card1Title", locale),
      description: getLocaleString("Feature2Card1Description", locale),
    },
    {
      icon: GiFactory,
      title: getLocaleString("Feature2Card2Title", locale),
      description: getLocaleString("Feature2Card2Description", locale),
    },
    {
      icon: MdConstruction,
      title: getLocaleString("Feature2Card3Title", locale),
      description: getLocaleString("Feature2Card3Description", locale),
    },
    {
      icon: FaSchool,
      title: getLocaleString("Feature2Card4Title", locale),
      description: getLocaleString("Feature2Card4Description", locale),
    },
    {
      icon: GiShop,
      title: getLocaleString("Feature2Card5Title", locale),
      description: getLocaleString("Feature2Card5Description", locale),
    },
    {
      icon: FaHospitalAlt,
      title: getLocaleString("Feature2Card6Title", locale),
      description: getLocaleString("Feature2Card6Description", locale),
    },
  ];

  return (
    <Container id="services">
      <ThreeColumnContainer>
        {subheading && <Subheading>{subheading}</Subheading>}
        <Heading>{heading}</Heading>
        {description && <Description>{description}</Description>}
        <VerticalSpacer />
        {cards.map((card, i) => (
          <Column key={i}>
            <Card>
              <span className="imageContainer">
                <card.icon style={{ color: "#11c2cf", fontSize: 25 }} />
              </span>
              <span className="textContainer">
                <span className="title">{card.title}</span>
                <p className="description">{card.description}</p>
              </span>
            </Card>
          </Column>
        ))}
      </ThreeColumnContainer>
      <DecoratorBlob />
    </Container>
  );
};
